import React from 'react';

interface Props {
  position: number;
  duration: number;
  onSlide: (position: number) => void;
}

export class SeekBar extends React.Component<Props> {
  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { onSlide } = this.props;
    const value = Number(e.currentTarget.value);

    onSlide(value);
  };

  getFormattedMinutes = (time: number) => {
    const minutesRough = time / 60;
    const minutes = Math.floor(minutesRough);
    const leftover = minutesRough - minutes;
    const seconds = Math.floor(leftover * 60);

    return `${minutes < 10 ? `0${minutes}` : minutes}:${
      seconds < 10 ? `0${seconds}` : seconds
    }`;
  };

  render() {
    const { position, duration } = this.props;
    /** The thumb snaps to whole seconds, so the fill reads off the same value. */
    const seconds = Math.floor(position);
    const progress = duration > 0 ? seconds / duration : 0;
    /** CSSProperties carries no index signature for custom properties. */
    const style = { '--seekbar-progress': progress } as React.CSSProperties;

    return (
      <React.Fragment>
        <div className="seekbar" style={style}>
          {duration > 0 && (
            <React.Fragment>
              <input
                type="range"
                min={0}
                max={duration}
                step={1}
                className="seekbar__slider"
                value={seconds}
                onChange={this.handleChange}
              />
              <div className="seekbar__background" />
              <div className="seekbar__progress" />
            </React.Fragment>
          )}
          {duration > 0 && (
            <div className="f f--center seekbar__duration">
              <p className="seekbar__time u-opacity--60">
                {this.getFormattedMinutes(position)}
              </p>
              <p className="seekbar__remaining u-opacity--40">
                {this.getFormattedMinutes(duration)}
              </p>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}
